/**
 * Рекурсивное сканирование директории "resources/js/core/components" и
 * автоматическая регистарция всех Vue-компонентов используя название файла в kebab-notation.
 *
 * Eg. ./components/VExampleComponent.vue -> <v-example-component></v-example-component>
 */

const context = require.context('./', true, /\.vue$/i);
context.keys().map(file => Vue.component(file.split('/').pop().split('.')[0], context(file).default));